<template>
    <div class="panel-body">
      <template>
        <v-card width="1000px">
        <v-data-table
          v-model="ConfigureModel"
          :headers="head2"
          :items="Configure"
          item-key="id"
          class="elevation-1"
          :rows-per-page="rowsPerPage"
          :items-per-page-options="rppItems"
        >
        <template slot="item" slot-scope="props">
          <tr>
            <td class="text-xs-center" width="500px">{{ props.item.userId }}</td>
            <td class="text-xs-center" width="500px">{{ props.item.firstName }}</td>
            <td class="text-xs-center" width="500px">{{ props.item.lastName }}</td>
            <td class="text-xs-center" width="500px">{{ formatDate(props.item.withdrewOn) }}</td>
            <td class="text-xs-center" width="500px">${{ props.item.loanAmount }}</td>
            <td class="text-xs-center" width="500px">${{ props.item.repaidAmount }}</td>
            <td class="text-xs-center" width="500px">{{ props.item.status }}</td>
            </tr>
        </template>
        <template slot="no-data">
        </template>
      </v-data-table>
      </v-card>
      </template>
    </div>
  </template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')
export default {
  props: {
    jarId: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }

  },
  data: () => ({
    loadingConfigure: false,
    rppItems: [
      10,
      50,
      100,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    ConfigureModel: [],
    errors: [],
    head2: [
      { text: 'User ID', align: 'left', sortable: false, value: 'userId' },
      { text: 'First Name', align: 'left', sortable: false, value: 'firstName' },
      { text: 'Last Name', align: 'left', sortable: false, value: 'lastName' },
      { text: 'Withdrew On', align: 'left', sortable: false, value: 'withdrewOn' },
      { text: 'Withdrawal Amount', align: 'left', value: 'loanAmount' },
      { text: 'Repaid Amount', align: 'left', value: 'repaidAmount' },
      { text: 'Status', align: 'left', value: 'status' }
    ],
    Configure: []
  }),
  created () {
    this.loadConfigure()
  },
  mounted () {
    this.loadConfigure()
  },
  watch: {
    jarId: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadConfigure()
      }
    }
  },

  methods: {

    async loadConfigure () {
      if (this.userId == null || this.userId === '' || this.jarId == null || this.jarId === '') {
        // console.log('User ID or Jar ID not set, unable to load jar Configure')
        this.Configure = []
        return
      }
      // this.loadingConfigure = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_JAR}/jars/withdrawal-history?jarId=${this.jarId}`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (getResponse === undefined) { this.Configure = [] } else { this.Configure = getResponse.data }
      // this.loadingConfigure = false
    },

    formatDate (aDate) {
      return moment(String(aDate)).format('MM/DD/YYYY hh:mm:ss')
    }
  }
}
</script>
<style>
</style>
